import {
  ErrorModal,
  type CartFulfillErrorModalProps,
  useCartFulfillErrorModal,
} from "@apac/components/ui";

export const CartFulfillErrorModal = (props: CartFulfillErrorModalProps) => {
  const { errorModalProps } = useCartFulfillErrorModal({ ...props });

  return <ErrorModal {...errorModalProps} {...props} />;
};
